<div class="gridContainer">

@if (isLoading()) {
    <p>Lädt...</p>
} @else if (buergschein && buergscheinLight) {

    <h1 class="goBack" (click)="goBack()">
        Bürgschein {{ buergscheinId }}
    </h1>

    <div class="gridContainer colorGrid bgsch-single">
        <div class="row">
            <div class="cell grid-25">
                <div class="dataBox">
                    <span class="label">
                        Höhe der Bürgschaft
                    </span>
                    <span class="value">
                        {{ buergschein.buergschaftsBetrag | formatMoney }}
                    </span>
                </div>
            </div>

            <div class="cell grid-25">
            @if (buergschein.ausstellungsdatum) {
                <div class="dataBox">
                    <span class="label">
                        {{ buergscheinLight.statusanzeigeBuergschaft === 'IN_BEARBEITUNG' ? 'Datum der Beantragung' : 'Datum der Ausstellung' }}
                    </span>
                    <span class="value">
                        {{ buergschein.ausstellungsdatum }}
                    </span>
                </div>
            }
            </div>

        @if (buergschein.befristungsDatum) {
            <div class="cell grid-50">
                <div class="dataBox">
                <span class="label">
                    Ablaufdatum
                </span>
                    <span class="value">
                    {{ buergschein.befristungsDatum }}
                </span>
                </div>
            </div>
        } @else {
            <div class="cell grid-50">
                <div class="dataBox">
                <span class="label">
                    Voraussichtlicher Ablauf
                </span>
                    <span class="value">
                    {{ buergschein.voraussichtlAblaufdatum }}
                </span>
                </div>
            </div>
        }
        </div>
    </div>

    <div class="gridContainer actionGrid">
        <div class="row">
            <div class="cell grid-100">
                <div class="actionsContainer">
                    @if (buergscheinLight.dokumentId && !buergscheinLight.originalDokumentId) {
                        <elem-button buttonRole="SECONDARY"
                                     icon="icon-document"
                                     (click)="downloadBuergschein(false)">Herunterladen</elem-button>
                    }

                    @if (buergscheinLight.dokumentId && buergscheinLight.originalDokumentId) {
                        <elem-button buttonRole="SECONDARY"
                                     icon="icon-document"
                                     (click)="downloadBuergschein(true)">Original herunterladen</elem-button>

                        <elem-button buttonRole="SECONDARY"
                                     icon="icon-document"
                                     (click)="downloadBuergschein(false)">Kopie herunterladen</elem-button>
                    }

                    <elem-button buttonRole="SECONDARY"
                                 icon="icon-duplicate"
                                 (click)="createBuergscheinWithVorlage()">Als Vorlage nutzen</elem-button>

                    @if (canModifyBs()) {
                        <elem-button buttonRole="SECONDARY"
                                     icon="icon-edit_1"
                                     (click)="createBuergscheinWithVorlage(true)">Änderungsauftrag</elem-button>

                        <print-enthaftungserklaerung [model]="buergschein" style="margin-left: 1rem"></print-enthaftungserklaerung>

                        @if (buergscheinLight.versandweg === 'TRUSTLOG') {
                            <elem-button buttonRole="SECONDARY"
                                         icon="icon-guarantee"
                                         style="margin-left: 1rem"
                                         [disabled]="rueckforderungLocked"
                                         (click)="rueckforderungBuergschaft()">Rückforderung</elem-button>
                        }
                    }
                </div>
            </div>
        </div>
    </div>

    <h2>
        Bürgschaftsdetails
    </h2>

    <div class="gridContainer dataGrid">
        <div class="row">
            <div class="cell grid-25">
                <span class="label">Auftraggeber</span>
                <span class="value">{{ buergscheinLight.auftraggeberInfo | pickCustomer }}</span>
            </div>
            <div class="cell grid-25">
                <span class="label">Bürgschaftsart</span>
                <span class="value">{{ translateBuergscheinArt(buergschein.buergschaftsArt) }}</span>
            </div>
            <div class="cell grid-25">
                <span class="label">Rechtsgrundlage</span>
                <span class="value">{{ buergschein.rechtsGrundlage }}</span>
            </div>
            <div class="cell grid-25">
                <span class="label">Formularart</span>
                <span class="value">{{ translate(buergschein.formularArt) }}</span>
            </div>
        </div>
        <div class="row">
            <div class="cell grid-25">
                <span class="label">Bürgscheinnummer</span>
                <span class="value">{{ buergscheinLight.buergscheinId }}</span>
            </div>
            <div class="cell grid-25">
                <span class="label">Zugehöriger Vertrag</span>
                <span class="value">{{ buergschein.vsnr }}</span>
            </div>
            <div class="cell grid-25">
                <span class="label">Auftrag vom</span>
                <span class="value">{{ buergschein.auftragsdatum }}</span>
            </div>
            <div class="cell grid-25">
                <span class="label">Geschäftszeichen</span>
                <span class="value">{{ buergschein.geschaeftszeichen }}</span>
            </div>
        </div>
    </div>


    <h2>
        Auftraggeberdetails
    </h2>

    <div class="gridContainer dataGrid">
        <div class="row">
            <div class="cell grid-100">
                {{ buergschein.auftraggeberinfo1 }}<br>
                {{ buergschein.auftraggeberinfo2 }}<br>
                {{ buergschein.auftraggeberinfo3 }}<br>
                {{ buergschein.auftraggeberinfo4 }}<br>
                {{ buergschein.auftraggeberinfo5 }}<br>
                {{ buergschein.auftraggeberinfo6 }}
            </div>
        </div>
    </div>


    <h2>
        Auftragsdetails
    </h2>

    <div class="gridContainer dataGrid">
        <div class="row">
            <div class="cell grid-100">
                {{ buergschein.auftrag1 }}<br>
                {{ buergschein.auftrag2 }}<br>
                {{ buergschein.auftrag3 }}<br>
                {{ buergschein.auftrag4 }}<br>
                {{ buergschein.auftrag5 }}<br>
                {{ buergschein.auftrag6 }}
            </div>
        </div>
    </div>

@if (neighborScheine && neighborScheine.length !== 0) {
    <div class="itemNavigation">
        <span class="prevItem" (click)="prev()">Vorheriger ({{ neighborScheine[0] }})</span>
        <span class="nextItem" (click)="next()">Nächster ({{ neighborScheine[1] }})</span>
    </div>
}

}

</div>




